import { isAgent } from "../../utils/nick-utils";
import { ChatMemberLeaveDetail } from "../ChatAction";
import { ChatState } from "../ChatState";
import { joinMessages } from "./joinMessages";

export function memberLeave(state: ChatState, detail: ChatMemberLeaveDetail): ChatState {
    const agents = { ...state.agents };
    const prevAgentInfo = state.agents[detail.user.nick];

    agents[detail.user.nick] = {
        ...prevAgentInfo,
        joined: false,
        typing: false
    };

    // count number of agents that are still joined
    const agentsJoined = Object.values(agents).filter((agent) => agent.joined);
    const isChatting = agentsJoined.length > 0;

    if (isAgent(detail.user.nick)) {
        return {
            ...state,
            isChatting,
            chats: prevAgentInfo?.joined ? joinMessages(state.chats, detail) : state.chats,
            agents
        };
    } else {
        return {
            ...state,
            isChatting,
            chats: joinMessages(state.chats, detail),
            agents
        };
    }
}